import LocaleProvider from "../../providers/LocaleProvider";

export function formatCurrency(amount: number): string {
  const currencySymbol = LocaleProvider.getCurrencySymbol();
  return `${currencySymbol}${amount.toFixed(2)}`;
}
